export default __webpack_public_path__ + "static/media/possible-world-portal.3ba05c52.png";